// ── PID: 사용자 (10xxx) ──────────────────────────────────
export const PID_USER_REGISTER = '10001'
export const PID_USER_LOGIN    = '10002'
export const PID_USER_LOGOUT   = '10003'

// ── PID: 캐릭터/게임 (20xxx) ────────────────────────────
export const PID_CHAR_LOAD       = '20001'
export const PID_CHAR_SAVE       = '20002'
export const PID_TURN_STATUS     = '20003'
export const PID_CHAR_MOVE       = '20004'
export const PID_GAME_CONFIG     = '20005'
export const PID_REGION_LIST     = '20006'
export const PID_HUNT_PLACE_LIST = '20007'

// ── PID: 행동 (21xxx) ────────────────────────────────────
export const PID_ACTION_START  = '21001'
export const PID_ACTION_CANCEL = '21002'
export const PID_ACTION_TICK   = '21003'

// ── PID: 무공 (22xxx) ────────────────────────────────────
export const PID_MUGONG_LIST   = '22001'
export const PID_MUGONG_LEARN  = '22002'
export const PID_MUGONG_MASTER = '22003'
export const PID_MUGONG_EQUIP  = '22004'

// ── PID: 행낭/장비 (23xxx) ──────────────────────────────
export const PID_INV_LIST    = '23001'
export const PID_INV_EQUIP   = '23002'
export const PID_INV_UNEQUIP = '23003'
export const PID_INV_DROP    = '23004'

// ── PID: 상점 (24xxx) ────────────────────────────────────
export const PID_SHOP_LIST = '24001'
export const PID_SHOP_BUY  = '24002'
export const PID_SHOP_SELL = '24003'

// ── PID: 거래소 (25xxx) ──────────────────────────────────
export const PID_TRADE_LIST   = '25001'
export const PID_TRADE_POST   = '25002'
export const PID_TRADE_BUY    = '25003'
export const PID_TRADE_CANCEL = '25004'

// ── PID: 문파 (26xxx) ────────────────────────────────────
export const PID_SECT_LIST         = '26001'
export const PID_SECT_APPLY        = '26002'
export const PID_SECT_ACCEPT       = '26003'
export const PID_SECT_REJECT       = '26004'
export const PID_SECT_LEAVE        = '26005'
export const PID_SECT_STORAGE_LIST = '26006'
export const PID_SECT_DEPOSIT      = '26007'
export const PID_SECT_WITHDRAW     = '26008'
export const PID_SECT_APPLY_LIST   = '26009'
export const PID_SECT_CREATE       = '26010'
export const PID_SECT_INFO              = '26011'
export const PID_ALCHEMY_RECIPE_LIST    = '26012'
export const PID_ALCHEMY_CREATE         = '26013'
export const PID_CRAFT_RECIPE_LIST      = '26014'
export const PID_CRAFT_CREATE           = '26015'
export const PID_SECT_VAULT_LIST    = '26016'
export const PID_SECT_VAULT_DEPOSIT = '26017'
export const PID_SECT_VAULT_WITHDRAW = '26018'
export const PID_SECT_FUND_DEPOSIT  = '26019'
export const PID_SECT_FUND_WITHDRAW = '26020'
export const PID_SECT_FUND_LOG      = '26021'

// ── PID: 마스터 (27xxx) ──────────────────────────────────
export const PID_ITEM_MASTER    = '27001'
export const PID_MONSTER_MASTER = '27002'
export const PID_FORTUNE_MASTER = '27003'
export const PID_HUNT_DROP_LIST = '27004'

// ── PID: 랭킹 (30xxx) ────────────────────────────────────
export const PID_RANK_LIST      = '30001'
export const PID_SECT_RANK_LIST = '30002'

// ── PID: 자동 소모품 (28xxx) ────────────────────────────
export const PID_AUTO_POTION_SET   = '28001'
export const PID_AUTO_POTION_QUERY = '28002'

// ── PID: 장비 강화 / 아이템 사용 (29xxx) ───────────────
export const PID_ITEM_ENHANCE = '29001'
export const PID_USE_ITEM     = '29002'

// ── PID: 이벤트 (40xxx) ──────────────────────────────────
export const PID_EVENT_BLOODCULT_STATUS = '40001'
export const PID_EVENT_BLOODCULT_LATEST = '40002'
